<template>
  <v-navigation-drawer app right permanent>
    <v-toolbar-title class="headline text-uppercase">
      <logo horizontal />
    </v-toolbar-title>

    <button
      v-if="$vuetify.breakpoint.mdAndDown"
      class="default-btn circle toggler"
      :class="[togglerColor]"
      @click="$emit('toggleSidenav')"
    ><v-icon size="36">mdi-reorder-horizontal</v-icon></button>

    <nav class="client-nav">
      <v-menu
        v-for="menu of menuItems"
        :key="menu.text"
        content-class="client-nav" :close-on-content-click="true" offset-y>
        <template v-slot:activator="{ on }">
          <button class="default-btn text nav-menu-item" v-on="on">
            {{ menu.text }}
          </button>
        </template>

        <v-list>
          <v-list-item
            v-for="child of menu.children"
            :key="child.text"
            :to="child.to">
            <v-list-item-title>{{ child.text }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <template v-if="!isAuthenticated">
        <router-link
          :to="{ name: 'SignUp' }"
          class="default-btn text"
        >Sign Up</router-link>

        <router-link
          :to="{ name: 'SignIn' }"
          class="default-btn text login"
        >Login</router-link>
      </template>

      <v-menu v-else content-class="client-nav" :close-on-content-click="true" offset-y>
        <template v-slot:activator="{ on }">
          <button
            class="default-btn text nav-menu-item"
            v-on="on">
            My Profile
            <v-icon>mdi-chevron-down</v-icon>
          </button>
        </template>

        <v-list>
          <v-list-item :to="{ name: 'LenderResults' }">
            <v-list-item-title>My Dashboard</v-list-item-title>
          </v-list-item>

          <v-list-item
            v-if="userData.role === 'admin'"
            :to="{ name: 'AdminDashboard' }"
          >
            <v-list-item-title>Admin Site</v-list-item-title>
          </v-list-item>

          <v-list-item
            v-if="userData.role === 'lender' && !userData.organization.hidden"
            :to="{
              name: 'OrganizationDashboard',
              params: { organizationId: userData.organizationId }
            }"
          >
            <v-list-item-title>My Organization Dashboard</v-list-item-title>
          </v-list-item>

          <v-list-item :to="{ name: 'AccountSettings' }">
            <v-list-item-title>Account Settings</v-list-item-title>
          </v-list-item>

          <v-list-item @click="onLogout">
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </nav>
  </v-navigation-drawer>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  name: 'SideNavbar',
  props: {
    togglerColor: {
      type: String,
      default: 'blue',
    },
  },
  data: () => ({
    menuItems: [
      {
        text: 'Resource Center',
        children: [
          {
            text: 'Amortization Calculator',
            to: { name: 'AmortizationCalculator' },
          },
          // hide for now until providers feature is ready to show
          // {
          //   text: 'Providers',
          //   to: { name: 'ProvidersList' },
          // },
        ],
      },
      {
        text: 'About',
        children: [
          {
            text: 'About us',
            to: { name: 'About' },
          },
          {
            text: 'FAQs',
            to: { name: 'Faq' },
          },
        ],
      },
    ],
  }),
  computed: {
    ...mapGetters('authStore', ['isAuthenticated']),
    ...mapState('authStore', {
      userData: 'userData',
    }),
  },
  methods: {
    ...mapActions('authStore', ['CLEAR_USER_DATA']),
    ...mapActions('feathers', ['logout']),

    async onLogout () {
      await this.logout()
      this.CLEAR_USER_DATA()
      this.$router.push({ name: 'Home' })
    },
  },
}
</script>

<style lang="scss" scoped>
.v-navigation-drawer {
  z-index: 9;
  overflow: visible;

  background-color: #F7F7F7 !important;

  font-family: "Sansation Regular", Serif;
  font-size: 20px;

  padding: 30px 20px;

  nav {
    display: flex;
    flex-direction: column;

    margin-top: 10px;

    & > * {
      margin-top: 10px;
    }
  }

  .toggler {
    position: absolute;
    top: 10px;
    left: -50px;
    z-index: 10;

    height: 40px;
    width: 40px;
    padding: 0;

    .v-icon {
      font-size: 24px !important;
    }
  }
}
</style>
